import {FC} from "react";
import {Drawer, drawerClasses, Stack} from "@mui/material";
import {styled} from "@mui/material/styles";
import Logo from "./Logo";
import MenuContent from "./MenuContent";
import MenuPanel from "./MenuPanel";
import {t} from "../../../styles/theme/tokens";

/**
 * SideMenuMobile — drawer для xs/sm экранов.
 *
 * Та же структура, что у десктопного SideMenu (Logo + content + MenuPanel),
 * но открывается справа поверх контента и закрывается тапом по backdrop'у
 * или по клику на пункт меню (через onItemClick).
 *
 * onItemClick=close прокинут И в MenuContent (пункты меню), И в MenuPanel
 * (иконки подвала: уведомления, баланс, профиль) — чтобы тап по любому из
 * них закрывал drawer одинаково.
 *
 * Не максимизируем ширину: 280–320px, явная max-width 84vw — оставляем
 * пользователю место сбоку для тапа-закрытия.
 */

interface SideMenuMobileProps {
    open: boolean;
    toggleDrawer: (newOpen: boolean) => () => void;
}

const StyledDrawer = styled(Drawer)({
    [`& .${drawerClasses.paper}`]: {
        backgroundColor: t.bg.paper,
        backgroundImage: "none",
        borderLeft: `1px solid ${t.divider}`,
        width: 300,
        maxWidth: "84vw",
        display: "flex",
        flexDirection: "column",
    },
});

const ScrollableArea = styled("div")({
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
});

const SideMenuMobile: FC<SideMenuMobileProps> = ({open, toggleDrawer}) => {
    const close = toggleDrawer(false);

    return (
        <StyledDrawer
            anchor="right"
            open={open}
            onClose={close}
            // zIndex выше FAB-кнопки бургера и AppBar (которые у тебя 1300)
            sx={{zIndex: 1400}}
        >
            <Stack sx={{height: "100%"}}>
                <Logo/>
                <ScrollableArea className="scroll-area">
                    <MenuContent onItemClick={close}/>
                </ScrollableArea>
                <MenuPanel onItemClick={close}/>
            </Stack>
        </StyledDrawer>
    );
};

export default SideMenuMobile;